import React, { Component } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import LinearProgress from "@mui/material/LinearProgress";
import {
  Typography,
  Link,
  Box,
  Stack,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Portal } from "@mui/base";
// import Container from '@material-ui/core/Container';
import Logo from "../images/logo120.png";
import CircularProgress from "@mui/material/CircularProgress";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AuthLayout from "../layouts/AuthLayout";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// components
import { MHidden } from "../components/@material-extend";
import { useState, forwardRef, useRef, useEffect } from "react";
import Page from "../components/Page";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";
import { CallApi } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// export default class Login extends Component {
export default function Login() {
  const [usernameErrorText, setusernameErrorText] = useState("");
  const [passwordErrorText, setPasswordErrorText] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [usernameValue, setusernameValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [serverResponse, setServerResponse] = useState(false);
  const [fnameErrorText, setFnameErrorText] = useState("");
  const [fnameValue, setFnameValue] = useState("");
  const [lnameErrorText, setLnameErrorText] = useState("");
  const [lnameValue, setLnameValue] = useState("");
  const [mobileErrorText, setMobileErrorText] = useState("");
  const [mobileValue, setMobileValue] = useState("");
  const [repasswordErrorText, setRepasswordErrorText] = useState("");
  const [rememberCheck, setRememberCheck] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);

  const usernameInput = useRef();
  const passInput = useRef();

  const navigate = useNavigate();

  useEffect(() => {
    let username = getCookie("username");
    let token = getCookie("token");
    if (!username || !token) {
      setServerResponse(true);
      return;
    }

    let data = {
      username: username,
      token: token,
    };
    CallApi("checkToken", "post", data)
      .then((result) => {
        if (result.status === 200) {
          navigate("/");
          return;
        } else {
          setServerResponse(true);
        }
      })
      .catch(() => {
        setServerResponse(true);
      });
  }, []);

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // function checkCookie(name) {
  //   let user = getCookie(name);
  //   if (user !== "") {
  //     alert("Welcome again " + user);
  //   } else {
  //     user = prompt("Please enter your name:", "");
  //     if (user !== "" && user != null) {
  //       setCookie("username", user, 365);
  //     }
  //   }
  // }

  const onSignIn = () => {
    if (!usernameValue) {
      setusernameErrorText("please enter your username address");
      usernameInput.current.focus();
      return;
    } else {
      setusernameErrorText("");
    }

    if (!passwordValue) {
      setPasswordErrorText("please enter your password");
      passInput.current.focus();
      return;
    } else {
      setPasswordErrorText("");
    }

    let data = {
      username: usernameValue,
      password: passwordValue,
    };

    setButtonDisabled(true);

    CallApi("login", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            setCookie("token", result.token, 365);
            setCookie("username", usernameValue, 365);
            navigate("/");
            return;
          } else if (result.status === 401) {
            setPasswordErrorText("username or password is wrong");
            passInput.current.focus();
          } else {
            setPasswordErrorText(result.message);
            passInput.current.focus();
          }
          setButtonDisabled(false);
        } catch (err) {
          setSnackType("error");
          setSnackbarMessage(err);
          setSnackbarOpen(true);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const handleKeyPress = (target) => {
    if (target.charCode === 13) {
      onSignIn();
    }
  };

  if (serverResponse) {
    return (
      <Page title="Login | Admin Panel">
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box className="loginForm">
            <Box className="logoContainer">
              <img
                src={Logo}
                alt=""
                style={{
                  width: "135px",
                  objectFit: "contain",
                }}
              />
            </Box>

            <Box className="paper">
              <form className="form" noValidate>
                <Box style={{ minHeight: "20px" }} />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="Username"
                  label="Username"
                  name="usernameValue"
                  autoFocus
                  color="primary"
                  helperText={usernameErrorText}
                  value={usernameValue}
                  onChange={(e) => setusernameValue(e.target.value)}
                  disabled={buttonDisabled}
                  onKeyPress={handleKeyPress}
                  inputRef={usernameInput}
                  error={usernameErrorText !== ""}
                  //   size="small"
                />
                <Box style={{ minHeight: "20px" }} />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  name="passwordValue"
                  label="Password"
                  type="password"
                  id="password"
                  color="primary"
                  helperText={passwordErrorText}
                  value={passwordValue}
                  onChange={(e) => setPasswordValue(e.target.value)}
                  disabled={buttonDisabled}
                  onKeyPress={handleKeyPress}
                  inputRef={passInput}
                  error={passwordErrorText !== ""}
                />
                {/* <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    mt: 1,
                    width: "100%",
                  }}
                >
                  <Box sx={{ flexGrow: 1 }} />
                  <Link
                    underline="none"
                    variant="body2"
                    component={RouterLink}
                    to={!buttonDisabled && "/forgotpassword"}
                  >
                    Forgot Password?
                  </Link>
                </Box> */}
                <Box style={{ minHeight: "30px" }} />
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className="submit"
                  disabled={buttonDisabled}
                  onClick={onSignIn.bind(this)}
                >
                  Log in
                </Button>
              </form>
            </Box>
            {/* <MHidden width="smDown">
              <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                Don’t have an account? &nbsp;
                <Link
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to={!buttonDisabled && "/register"}
                >
                  Register Now
                </Link>
              </Box>
            </MHidden>
            <MHidden width="smUp">
              <Typography variant="body2" align="center" sx={{ mt: 3 }}>
                Don’t have an account?&nbsp;
                <Link
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to={!buttonDisabled && "/register"}
                >
                  Register Now
                </Link>
              </Typography>
            </MHidden> */}
            {buttonDisabled && (
              <LinearProgress
                color="primary"
                style={{
                  zIndex: "100000",
                  width: "100%",
                  position: "absolute",
                  bottom: "0px",
                  marginLeft: "-20px",
                }}
              />
            )}
          </Box>
        </Box>
        <Portal>
          <Snackbar
            open={snackbarOpen}
            onClose={() => setSnackbarOpen(false)}
            TransitionComponent={SlideTransition}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert
              onClose={() => setSnackbarOpen(false)}
              severity={snackType}
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </Portal>
      </Page>
    );
  } else {
    return (
      <CircularProgress
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        color="primary"
      />
    );
  }
  // }
}
